import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import * as UserReducer from '../../redux/reducers/User';
export var useCurrentUser = function() {
    var _useSelector = useSelector(UserReducer.getCurrentUser), currentUser = _useSelector.data;
    var user = useMemo(function() {
        return currentUser;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        JSON.stringify(currentUser)
    ]);
    return {
        user: user
    };
};
